module.exports = __webpack_public_path__ + "static/Artifact Preservation-0327ef442246c98f96fee3e7f87bd6f6.pdf";